import React from 'react';
import PropTypes from 'prop-types';
import css from './Input.scss';

const Input = React.forwardRef((inputProps, ref) => {
  const {hasError, ...rest} = inputProps;
  const errorClassName = hasError ? css['error'] : '';
  return (
    <div className={`${css['input-wrapper']} ${errorClassName}`}>
      <input {...rest} ref={ref} />
    </div>  
  )
});

Input.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
   ]),
  onChange: PropTypes.func,
  hasError: PropTypes.bool
}

export default Input;
